<template>
  <div v-if="image.url">
    <v-layout column class="py-4 px-4 pb-4">
      <v-card hover class="d-flex">
        <v-tooltip color="blue darken-4" top max-width="250">
          <template v-slot:activator="{ on, attrs }">
            <v-img
              :contain="false"
              :src="image.url"
              :aspect-ratio="'1'"
              :class="'image grey lighten-2'"
              :style="'cursor: pointer'"
              @click="$emit('click', image.index)"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>{{image.title}}</span>
        </v-tooltip>
      </v-card>
      <strong>
        <p
          class="mt-2 mb-0 img-text img-title"
        >{{image.title || ""}}</p>
      </strong>
        <p v-if="image.description"
          class="mt-2 mb-0 img-text img-description"
        >{{image.description}}</p>

      <v-progress-circular v-if="showProgressCircular" style="margin-left:23px;" indeterminate></v-progress-circular>
      <v-layout v-else :class="breakpointButtons">
        <v-btn icon :color="'primary'" :class="'mx-auto'" @click="setEditDescriptionDialog(true)">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn icon :color="'error'" :class="'mx-auto'" @click="setDeletionDialog(true)">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-layout>
    </v-layout>

    <deletion-dialog
      v-if="deletionDialog"
      :title="'Exclusão'"
      :enabled="deletionDialog"
      :dialogColor="'error'"
      :confirmationButtonColor="'error'"
      :confirmationButtonMessage="'Excluir'"
      :confirmationMessage="'Você tem certeza que deseja excluir a imagem? Ela não será mais acessível.'"
      @abort="closeDeletionDialog(false)"
      @confirm="closeDeletionDialog(true)"
    />

    <edit-description-dialog
      v-if="editDescriptionDialog"
      :imageDescription="image.description || ''"
      :enabled="editDescriptionDialog"
      @closed="setEditDescriptionDialog(false)"
      @submit="updateDescription"
    />
  </div>
</template>

<script>
import DeletionDialog from "@/components/templates/ConfirmationDialog";
import EditDescriptionDialog from './EditDescriptionDialog'
export default {
  components: { DeletionDialog, EditDescriptionDialog },
  props: {
    image: { required: true, type: Object },
    deletingFile: { required: true }
  },
  data: () => ({
    deletionDialog: false,
    editDescriptionDialog: false,
    breakpoints: {
      'lg': '8', 
      'md': '6', 
      'sm': '6', 
      'xs': '3',
      'xl': '3', 
    }
  }),
  computed: {
    showProgressCircular() {
      const { deletingFile, image } = this;
      return deletingFile ? deletingFile.title === image.title : false;
    },
    breakpointButtons() {
      const breakpoint = `px-${this.breakpoints[this.$vuetify.breakpoint.name]}` 
      return breakpoint
    },
  },
  methods: {
    setDeletionDialog(state) {
      this.deletionDialog = state;
    },
    setEditDescriptionDialog(state) {
      this.editDescriptionDialog = state;
    },
    closeDeletionDialog(confirm) {
      this.setDeletionDialog(false);
      if (confirm) 
        this.$emit("delete", this.image);
    },
    updateDescription(description) {
      const updatedImage = Object.assign(this.image, { description })
      this.$emit('update', updatedImage)
    },
    
  }
};
</script>

<style scoped>
.image {
  cursor: pointer;
  width: 100%;
}

.img-text {
  color: black; 
  text-overflow: ellipsis;           
}

.img-description {
  overflow: hidden;
  text-align: justify;
}

.img-title {
  white-space: nowrap;
  overflow: hidden;
}

</style>
